import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import remote from './remote'
import invoice from './modules/invoice'
import vismaart from './modules/vismaart'
import invoiceconfig from './modules/invoiceconfig'
import customer from './modules/customer'
import feralcoprice from './modules/feralcoprice'
import order from './modules/order'
import feralcoarticle from './modules/feralcoarticle'
import vehicles from './modules/vehicles'
import drivers from './modules/drivers'
import invoicedmts from './modules/invoicedmts'
import defaultevents from './modules/defaultevents'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    status: '',
    token: localStorage.getItem('token') || '',
    user: {}
  },
  mutations: {
    auth_request (state) {
      state.status = 'loading'
    },
    auth_success (state, token, user) {
      state.status = 'success'
      state.token = token
      state.user = user
    },
    auth_error (state) {
      state.status = 'error'
    },
    logout (state) {
      state.status = ''
      state.token = ''
    }
  },
  actions: {
    login ({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit('auth_request')
        axios({ url: '/api/login', data: { login: user }, method: 'POST' })
          .then(resp => {
            const token = resp.data.token
            const user = resp.data.user
            localStorage.setItem('token', token)
            localStorage.setItem('userId', user.id)
            localStorage.setItem('firstName', user.firstName)
            localStorage.setItem('lastName', user.lastName)
            localStorage.setItem('role', user.role)
            localStorage.setItem('userCustomerId', user.customerId)
            delete Vue.prototype.$http
            Vue.prototype.$http = remote()
            axios.defaults.headers.common['Authorization'] = token
            commit('auth_success', token, user)
            resolve(resp)
          })
          .catch(err => {
            commit('auth_error')
            localStorage.removeItem('token')
            localStorage.removeItem('userId')
            localStorage.removeItem('firstName')
            localStorage.removeItem('lastName')
            localStorage.removeItem('role')
            localStorage.removeItem('userCustomerId')
            reject(err)
          })
      })
    },
    logout ({commit}) {
      return new Promise((resolve, reject) => {
        commit('logout')
        localStorage.removeItem('token')
        localStorage.removeItem('userId')
        localStorage.removeItem('firstName')
        localStorage.removeItem('lastName')
        localStorage.removeItem('role')
        localStorage.removeItem('userCustomerId')
        delete axios.defaults.headers.common['Authorization']
        resolve()
      })
    }
  },
  getters: {
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status
  },
  modules: {
    invoice,
    vismaart,
    invoiceconfig,
    customer,
    feralcoprice,
    order,
    feralcoarticle,
    vehicles,
    drivers,
    invoicedmts,
    defaultevents
  }
})



// WEBPACK FOOTER //
// ./src/store.js